import { getLocalizedString } from "./get-localized-string.js";
const getLineItemDiscount = (price, locale, discounts) => {
  const productDiscount = discounts?.find((discount) => discount.type === "ProductDiscount");
  return {
    validFrom: productDiscount?.validFrom ?? void 0,
    validUntil: productDiscount?.validUntil ?? void 0,
    absoluteValue: price?.total.discount.amount || 0,
    relativeValue: price ? Number((price.total.discount.percentage * 100).toFixed(2)) : 0,
    description: getLocalizedString(locale, productDiscount?.description)
  };
};
export {
  getLineItemDiscount
};
//# sourceMappingURL=get-line-item-discount.js.map
